import { useState } from "react"
import { Modal } from "components"
import Label from "components/forms/label"
import Input from "components/forms/input"
import SelectDescription from "components/forms/select-description"
import { lang } from "config"

const Content = ({ data, errors, onSubmit, onRemove }) => {

  const [reference_type, setReferenceType] = useState(data.reference_type)
  const [date_from, setDateFrom] = useState(data.date_from)
  const [date_to, setDateTo] = useState(data.date_to)

  const referenceOptions = [
    { id: "GR_POST", name: "GR Post" },
    { id: "GR_CANCEL", name: "GR Cancel" },
    { id: "PO_RETURN", name: "PO Return" },
    { id: "PO_RETURN_CANCEL", name: "PO Return Cancel" },
    { id: "SALES", name: "Sales" },
    { id: "SALES_CANCEL", name: "Sales Cancel" },
    { id: "STOCK_OPNAME", name: "Stock Opname" },
    { id: "STOCK_INIT", name: "Stock Initial" },
    { id: "STOCK_ADJUSTMENT", name: "Stock Adjustment" },
    { id: "ORDER_REDUCTION", name: "Order Reduction" },
    { id: "ORDER_RESTORATION", name: "Order Restoration" },
    { id: "TRANSFER_IN", name: "Transfer In" },
    { id: "TRANSFER_OUT", name: "Transfer Out" },
    { id: "RETURN_TRANSACTION", name: "Return Transaction" },
    { id: "RETURN_TRANSACTION_CANCEL", name: "Return Transaction Cancel" }
  ]

  const handleSubmit = (e) => {
    e.preventDefault()

    const payload = {
      reference_type,
      date_from,
      date_to
    }

    onSubmit(
      Object.fromEntries(
        Object.entries(payload).filter(([_, v]) => v != null && v !== "")
      )
    )
  }

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-8">

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">

        <div>
          <Label value="Reference Type" />
          <SelectDescription
            selection={referenceOptions}
            value={reference_type}
            onChange={(value) => setReferenceType(value)}
            keyValue={(v) => v.id}
            title={(v) => v.name}
            placeholder="Select Type"
          />
        </div>

        <div>
          <Label value="Date From" />
          <Input
            type="date"
            value={date_from || ""}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </div>

        <div>
          <Label value="Date To" />
          <Input
            type="date"
            value={date_to || ""}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </div>

      </div>

      <div className="flex items-center space-x-2 text-xs">

        <button
          type="submit"
          className="px-6 py-3 text-white transition bg-neutral-800 rounded-xl"
        >
          {lang.filter}
        </button>

        <button
          type="button"
          onClick={onRemove}
          className="px-6 py-3 transition border border-neutral-200 bg-neutral-50 rounded-xl"
        >
          {lang.clear}
        </button>

      </div>

    </form>
  )
}

const Filter = ({ data, errors, onSubmit, onRemove }) => {

  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  const handleSubmit = (value) => {
    closeModal()
    onSubmit(value)
  }

  const handleRemove = () => {
    closeModal()
    onRemove()
  }

  return (
    <>
      <button
        onClick={openModal}
        className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl"
      >

        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none">
          <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"/>
        </svg>

        <span>{lang.filter}</span>

        {Object.keys(data || {}).length > 0 && (
          <span className="inline-flex w-4 h-4 font-semibold rounded-full text-[0.5rem] justify-center text-neutral-200 bg-neutral-800">
            {Object.keys(data).length}
          </span>
        )}

      </button>

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={`${lang.filter} ${lang.data}`}
        content={
          <Content
            errors={errors}
            onSubmit={handleSubmit}
            onRemove={handleRemove}
            data={data || {}}
          />
        }
      />

    </>
  )
}

export default Filter
